<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="contacts" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="contactId" selectionMode="single"
  [(selection)]="contact" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPaginator()" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Subscription Emails</h1>
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <button pButton pRipple class="p-button" style="margin-right: 20px;padding: 0.643rem 0.75rem !important;"
        (click)="onImportContact()">Import Contacts</button>

        <button pButton pRipple class="p-button" style="margin-right: 20px;padding: 0.643rem 0.75rem !important;"
        (click)="onExportContacts()" title="Current filter will be applied">Export Contacts</button>
        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Contact +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}">Tags</th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'emailAddress', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mobilePhone', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><app-tag-join-filter-select [tagSource]="80" (getFilteredTags)="getFilteredTags($event)"></app-tag-join-filter-select></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-contact>
    <tr [pSelectableRow]="contact">
      <td>{{contact.firstName}}</td>
      <!-- <td><span *ngFor="let owner of contact?.contactVOList;let i=index">{{i+1}}> {{owner?.lastName}} <br/> </span></td> -->
      <td>{{contact.lastName}}</td>
      <td>{{contact.emailAddress}}</td>
      <td>{{contact.mobilePhone}}</td>
      <app-tag-join-list-select [tagSource]="80" [tagSourceId]="contact.contactId" tagType="4"></app-tag-join-list-select>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(contact)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>
